<main class="landing-page">
  <section class="hero-section" id="top">
    <div class="hero-media" aria-hidden="true">
      <img src="assets/images/store-front-peony.jpg" alt="" />
    </div>

    <div class="hero-content">
      <p class="section-kicker hero-kicker">
        {{ 'landing.hero.kicker' | translate }}
      </p>
      <h1>{{ 'landing.hero.title' | translate }}</h1>
      <p class="hero-lead">
        {{ 'landing.hero.lead' | translate }}
      </p>

      <div class="hero-actions" aria-label="Fő műveletek">
        <a
          class="button-link primary"
          href="https://shop.twogetherflower.hu"
          target="_blank"
          rel="noopener"
        >
          {{ 'landing.hero.shopCta' | translate }}
        </a>
        <a
          class="button-link secondary"
          href="https://wolt.com/hu/hun/budapest/venue/dd-twogether-flowers-and-more"
          target="_blank"
          rel="noopener"
        >
          {{ 'landing.hero.woltCta' | translate }}
        </a>
        <a class="button-link secondary" href="tel:+36300121051">
          {{ 'landing.hero.primaryCta' | translate }}
        </a>
        <a class="button-link secondary" routerLink="/szolgaltatasok">
          {{ 'landing.hero.secondaryCta' | translate }}
        </a>
      </div>

      <div class="hero-facts" #reveal>
        <div>
          <span>{{ 'landing.hero.fact1.label' | translate }}</span>
          <strong>{{ 'landing.hero.fact1.value' | translate }}</strong>
        </div>
        <div>
          <span>{{ 'landing.hero.fact2.label' | translate }}</span>
          <strong>{{ 'landing.hero.fact2.value' | translate }}</strong>
        </div>
        <div>
          <span>{{ 'landing.hero.fact3.label' | translate }}</span>
          <strong>{{ 'landing.hero.fact3.value' | translate }}</strong>
        </div>
      </div>
    </div>

    <aside class="hero-card" #reveal>
      <span>{{ 'landing.hero.cardEyebrow' | translate }}</span>
      <p>{{ 'landing.hero.cardText' | translate }}</p>
      <div class="hero-card-actions">
        <a
          href="https://shop.twogetherflower.hu"
          target="_blank"
          rel="noopener"
        >
          {{ 'landing.hero.cardCta' | translate }}
        </a>
        <a
          href="https://wolt.com/hu/hun/budapest/venue/dd-twogether-flowers-and-more"
          target="_blank"
          rel="noopener"
        >
          {{ 'landing.hero.cardWoltCta' | translate }}
        </a>
      </div>
    </aside>
  </section>

  <section class="announcement-strip" #reveal>
    <span>{{ 'landing.announcement.label' | translate }}</span>
    <p>{{ 'landing.announcement.text' | translate }}</p>
  </section>

  <section class="webshop-section" #reveal>
    <div class="webshop-copy">
      <p class="section-kicker">{{ 'landing.webshop.kicker' | translate }}</p>
      <h2>{{ 'landing.webshop.title' | translate }}</h2>
      <p>{{ 'landing.webshop.text' | translate }}</p>
      <div class="webshop-actions">
        <a
          class="button-link primary"
          href="https://shop.twogetherflower.hu"
          target="_blank"
          rel="noopener"
        >
          {{ 'landing.webshop.primaryCta' | translate }}
        </a>
        <a
          class="button-link quiet"
          href="https://wolt.com/hu/hun/budapest/venue/dd-twogether-flowers-and-more"
          target="_blank"
          rel="noopener"
        >
          {{ 'landing.webshop.woltCta' | translate }}
        </a>
        <a class="button-link quiet" routerLink="/kapcsolat">
          {{ 'landing.webshop.secondaryCta' | translate }}
        </a>
      </div>
    </div>
    <div class="webshop-image">
      <img src="assets/images/carousel-order-wolt.jpg" [alt]="'landing.webshop.imageAlt' | translate" />
    </div>
  </section>

  <section class="section-shell services-section" id="services">
    <div class="section-heading" #reveal>
      <p class="section-kicker">{{ 'landing.services.kicker' | translate }}</p>
      <h2>{{ 'landing.services.title' | translate }}</h2>
      <p>{{ 'landing.services.lead' | translate }}</p>
    </div>

    <div class="service-grid">
      <article
        class="service-card"
        *ngFor="let service of services; let index = index"
        #reveal
        [style.transitionDelay.ms]="index * 110"
      >
        <img [src]="service.image" [alt]="service.altKey | translate" />
        <div class="service-card-content">
          <span>0{{ index + 1 }}</span>
          <h3>{{ service.titleKey | translate }}</h3>
          <p>{{ service.descriptionKey | translate }}</p>
          <a routerLink="/szolgaltatasok">{{ 'landing.services.moreCta' | translate }}</a>
        </div>
      </article>
    </div>
  </section>

  <section class="section-shell about-section" id="about">
    <div class="about-copy" #reveal>
      <p class="section-kicker">{{ 'landing.about.kicker' | translate }}</p>
      <h2>{{ 'landing.about.title' | translate }}</h2>
      <p class="large-copy">{{ 'landing.about.lead' | translate }}</p>

      <div class="quality-list" aria-label="Előnyök">
        <span>{{ 'landing.about.badge1' | translate }}</span>
        <span>{{ 'landing.about.badge2' | translate }}</span>
        <span>{{ 'landing.about.badge3' | translate }}</span>
      </div>

      <a class="text-link" routerLink="/rolunk">{{ 'landing.about.moreCta' | translate }}</a>
    </div>

    <div class="about-gallery" #reveal>
      <img class="gallery-main" src="assets/images/tavaszi_csokor.jpg" [alt]="'landing.about.image1' | translate" />
      <img class="gallery-float" src="assets/images/viragdoboz.jpg" [alt]="'landing.about.image2' | translate" />
    </div>
  </section>

  <section class="visit-section" id="visit">
    <div class="visit-image" #reveal>
      <img src="assets/images/store-front-peony.jpg" [alt]="'landing.visit.imageAlt' | translate" />
    </div>

    <div class="visit-panel" #reveal>
      <p class="section-kicker">{{ 'landing.visit.kicker' | translate }}</p>
      <h2>{{ 'landing.visit.title' | translate }}</h2>
      <p>{{ 'landing.visit.text' | translate }}</p>

      <dl class="visit-details">
        <div>
          <dt>{{ 'landing.visit.addressLabel' | translate }}</dt>
          <dd>{{ 'landing.visit.address' | translate }}</dd>
        </div>
        <div>
          <dt>{{ 'landing.visit.phoneLabel' | translate }}</dt>
          <dd><a href="tel:+36300121051">+36-30/012-1051</a></dd>
        </div>
        <div>
          <dt>{{ 'landing.visit.deliveryLabel' | translate }}</dt>
          <dd>{{ 'landing.visit.delivery' | translate }}</dd>
        </div>
      </dl>

      <div class="visit-actions">
        <a
          class="button-link primary"
          href="https://shop.twogetherflower.hu"
          target="_blank"
          rel="noopener"
        >
          {{ 'landing.visit.orderCta' | translate }}
        </a>
        <a
          class="button-link quiet"
          href="https://wolt.com/hu/hun/budapest/venue/dd-twogether-flowers-and-more"
          target="_blank"
          rel="noopener"
        >
          {{ 'landing.visit.woltCta' | translate }}
        </a>
        <a
          class="button-link quiet"
          routerLink="/kapcsolat"
        >
          {{ 'landing.visit.moreCta' | translate }}
        </a>
      </div>
    </div>
  </section>

  <section class="gallery-strip" aria-label="Virág galéria">
    <div
      class="gallery-tile"
      *ngFor="let item of gallery; let index = index"
      #reveal
      [style.transitionDelay.ms]="index * 90"
    >
      <img [src]="item.image" [alt]="item.altKey | translate" />
    </div>
  </section>

  <section class="final-cta" #reveal>
    <p class="section-kicker">{{ 'landing.final.kicker' | translate }}</p>
    <h2>{{ 'landing.final.title' | translate }}</h2>
    <p>{{ 'landing.final.text' | translate }}</p>
    <div class="final-actions">
      <a
        class="button-link primary"
        href="https://shop.twogetherflower.hu"
        target="_blank"
        rel="noopener"
      >
        {{ 'landing.final.shopCta' | translate }}
      </a>
      <a
        class="button-link secondary"
        href="https://wolt.com/hu/hun/budapest/venue/dd-twogether-flowers-and-more"
        target="_blank"
        rel="noopener"
      >
        {{ 'landing.final.woltCta' | translate }}
      </a>
      <a class="button-link secondary" href="tel:+36300121051">
        {{ 'landing.final.callCta' | translate }}
      </a>
      <a class="button-link secondary" href="mailto:twogetherflower@gmail.com">
        {{ 'landing.final.mailCta' | translate }}
      </a>
    </div>
  </section>
</main>

<button
  class="scroll-to-top"
  type="button"
  title="Ugrás az oldal tetejére"
  *ngIf="showScrollTop"
  (click)="scrollToTop()"
>
  ↑
</button>
